/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type RoleDtoRole = typeof RoleDtoRole[keyof typeof RoleDtoRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleDtoRole = {
  customerServiceAssistant: 'customerServiceAssistant',
  clientAdministrator: 'clientAdministrator',
  simpleUser: 'simpleUser',
} as const;
